import { Lang, LangStringMap } from 'contexts/LanguageContext'
import React, { createContext, useState, useContext } from 'react';

export interface Subscription {
  id: string;
  dateEcheance: string;
  nombreInscriptions: number;
  abonnement?: TypeAbonnement;
  nomOrganisation?: string;
  prenom?: string;
  nom?: string;
  emailAdress?: string;
  langue?: Lang;
}

export interface TypeAbonnement {
  id: string;
  titre: LangStringMap;
}

interface SubscriptionContextType {
  subscription: Subscription | null;
  setSubscription: React.Dispatch<React.SetStateAction<Subscription | null>>;
  subscriptionError: string | null;
  setSubscriptionError: React.Dispatch<React.SetStateAction<string | null>>;
}

const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

export const SubscriptionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const [subscriptionError, setSubscriptionError] = useState<string | null>(null);

  return (
    <SubscriptionContext.Provider value={{ subscription, setSubscription, subscriptionError, setSubscriptionError }}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = (): SubscriptionContextType => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
};